import React from 'react';
import { Select, Tag as AntTag } from 'antd';
import { Tags } from 'lucide-react';
import { useTagFilterController } from './tagFilter.controller';

const { Option } = Select;

/**
 * Reusable component for filtering items by tags
 * @param {string} modelType - Type of model to filter (User, Client, Store, etc.)
 * @param {function} onFilterChange - Callback with selected tag IDs
 * @param {string} placeholder - Placeholder text
 */
function TagFilter({ modelType, onFilterChange, placeholder = 'Filtrar por etiqueta...' }) {
    const { tags, loading, selectedTags, handleChange } = useTagFilterController({ modelType, onFilterChange });

    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;
        const tag = tags.find((t) => t._id === value);

        return (
            <AntTag color={tag?.color} closable={closable} onClose={onClose} className="!mr-1">
                {label}
            </AntTag>
        );
    };

    return (
        <Select
            mode="multiple"
            placeholder={placeholder}
            value={selectedTags}
            onChange={handleChange}
            loading={loading}
            className="min-w-[200px]"
            tagRender={tagRender}
            suffixIcon={<Tags className="text-surface-400" />}
            allowClear
            showSearch
            optionFilterProp="label">
            {tags.map((tag) => (
                <Option key={tag._id} value={tag._id} label={tag.name}>
                    <span className="flex items-center gap-2">
                        <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: tag.color }} />
                        {tag.name}
                    </span>
                </Option>
            ))}
        </Select>
    );
}

export default TagFilter;
